import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TenantList from "../../components/Tenants/TenantList";
import AddTenantModal from "../../components/Tenants/AddTenantModal";

function Tenants() {
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleAddTenant = () => {
    setShowAddModal(true);
  };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };

  const handleTenantAdded = (newTenant) => {
    console.log("New tenant added:", newTenant);
    // Trigger a refresh of the tenant list
    setRefreshTrigger(prev => prev + 1);
  };

  const handleViewDetails = (tenant) => {
    if (!tenant?._id) return;
    navigate(`/tenants/${tenant._id}`);
  };

  return (
    <div>
      <TenantList 
        key={refreshTrigger} // Force re-render when a new tenant is added
        onAddTenant={handleAddTenant}
        onViewDetails={handleViewDetails}
      />
      
      <AddTenantModal
        show={showAddModal}
        handleClose={handleCloseAddModal}
        onTenantAdded={handleTenantAdded}
      />
    </div>
  );
}

export default Tenants;